import { render, staticRenderFns } from "./KeywordModalCard.vue?vue&type=template&id=8bf05d94&scoped=true"
import script from "./KeywordModalCard.vue?vue&type=script&lang=js"
export * from "./KeywordModalCard.vue?vue&type=script&lang=js"
import style0 from "./KeywordModalCard.vue?vue&type=style&index=0&id=8bf05d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf05d94",
  null
  
)

export default component.exports